import request from './request'

// 1. 企业认证输入
export const getCertification = (data) =>
	request({
		url: '/api/login/business/verify/submit',
		method: 'post',
		data
	})

// 2. 企业认证（发送邮箱验证码）
export const getEmail = (data) =>
	request({
		url: '/api/login/business/send/mail/captcha',
		method: 'post',
		data
	})

// 3. 企业认证（邮箱认证）
export const getEmailbox = (data) =>
	request({
		url: '/api/login/business/mailbox/bind/relation',
		method: 'post',
		data
	})